"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M0 11V9h2a1 1 0 010 2H0zm20-2v2h-3a1 1 0 110-2h3zM5 9a1 1 0 000 2h3a1 1 0 100-2H5zm5 1a1 1 0 011-1h3a1 1 0 110 2h-3a1 1 0 01-1-1zM17 0h-2v4H4V0H2v5c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V0zM2 20h2v-4h11v4h2v-5c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v5z"];
//# sourceMappingURL=page-break.js.map